import { Box, Grid, Stack, Typography, Card, CardActionArea, Radio, Chip, Divider } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setRateCardMode, syncArrangementMode } from '../../../../redux/pricingWizardSlice';
import SectionTitle from './SectionTitle';

// v6.2 — Rate Card Mode (Blended vs Courier-Wise). Renders BETWEEN Payment & Credit
// and the AI Extract card. Drives preview tabs, per-service arrangement mode, the
// Rate Card builder structure, Review pane and commit exports.
export default function RateCardSetupCard() {
  const dispatch = useDispatch();
  const rateCardMode = useSelector((s) => s.pricingWizard.rateCardMode);

  const pick = (mode) => {
    dispatch(setRateCardMode(mode));
    dispatch(syncArrangementMode());
  };

  const options = [
    {
      id: 'blended', tag: 'BLENDED', tagBg: '#dcfce7', tagFg: '#166534',
      title: 'Blended Rate Card',
      sub: 'Single zone × slab matrix + one set of T&Cs applies to every courier in scope. Preview modal shows one tab; Rate Card builder shows one matrix. Simpler ops · best for smart-routing commercials.',
    },
    {
      id: 'courier_wise', tag: 'COURIER-WISE', tagBg: '#ede9fe', tagFg: '#5b21b6',
      title: 'Courier-Wise Rate Card',
      sub: 'Per-courier-parent rates + T&Cs with a blended fallback. Preview shows Default + one tab per parent; Rate Card builder shows per-parent tabs. Use when each courier negotiates its own pricing.',
    },
  ];

  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ mb: 2 }} />
      <SectionTitle icon="🧭" title="Rate Card Setup" badge="drives Arrangement + Rate Card + Review flow" />
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5, mb: 1.25 }}>
        Pick how the merchant's rate card is structured. <b>Blended</b> = one set of rates + T&Cs for every courier (ProShip
        smart-routing picks). <b>Courier-Wise</b> = each courier-parent gets its own rates + T&Cs override.
      </Typography>
      <Grid container spacing={1.5}>
        {options.map((o) => {
          const checked = rateCardMode === o.id;
          return (
            <Grid item xs={12} md={6} key={o.id}>
              <Card variant="outlined" sx={{ height: '100%', borderColor: checked ? 'primary.main' : 'divider', bgcolor: checked ? 'primary.lighter' : 'background.paper', '&:hover': { borderColor: 'primary.light', bgcolor: checked ? 'primary.lighter' : (t) => alpha(t.palette.primary.main, 0.04) } }}>
                <CardActionArea onClick={() => pick(o.id)} sx={{ p: 1.5, height: '100%' }}>
                  <Stack direction="row" spacing={1.25} alignItems="flex-start">
                    <Radio checked={checked} sx={{ p: 0.25, pointerEvents: 'none' }} />
                    <Box sx={{ flex: 1 }}>
                      <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 0.5 }}>
                        <Chip label={o.tag} size="small" sx={{ height: 18, fontSize: 9.5, fontWeight: 700, bgcolor: o.tagBg, color: o.tagFg }} />
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{o.title}</Typography>
                      </Stack>
                      <Typography variant="caption" sx={{ color: 'text.secondary' }}>{o.sub}</Typography>
                    </Box>
                  </Stack>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
